export const SET_LOGON = 'setLogon'
export const REFRESH_USER = 'refreshUser'
export const REFRESH_LOGIN = 'refreshLogin'
export const CLEAR_TOKEN = 'clearToken'
export const GET_APPS = 'getApps'
export const GET_USER = 'getUser'
export const LOGOFF_USER = 'logoffUser'
export const SET_ACCOUNT_COMPONENT = 'setAccountComponent'
export const CHANGE_PASSWORD = 'changePassword'
export const SET_LOGO_PATH = 'setLogoPath'
